"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TutorialTitle;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function TutorialTitle(_ref) {
  let {
    title,
    subTitle
  } = _ref;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)("");
  return /*#__PURE__*/_react.default.createElement(StyledTitleContainer, {
    lang: i18n.language
  }, /*#__PURE__*/_react.default.createElement(StyledTitle, null, title), /*#__PURE__*/_react.default.createElement(StyledSubTitle, null, subTitle));
}
const StyledTitleContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #fff;\n  font-style: normal;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n  flex-wrap: ", ";\n\n  @media (min-width: 768px) {\n    font-size: 28px;\n    flex-direction: ", ";\n  }\n"])), props => props.lang == "zh" ? "column" : "column-reverse", props => props.lang == "zh" ? "wrap" : "wrap-reverse", props => props.lang == "zh" ? "row" : "row-reverse");
const StyledTitle = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 28px;\n  font-weight: 600;\n\n  @media (min-width: 768px) {\n    font-size: 32px;\n  }\n"])));
const StyledSubTitle = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 500;\n\n  @media (min-width: 768px) {\n    font-size: 32px;\n    margin: 10px;\n  }\n"])));